import React, { useState, useRef, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import '../../assets/css/Forms.css'
import '../../assets/css/DialogDemo.css'
import { Column } from 'primereact/column';
import ConfirmBtn from "./ConfirmBtn";
import BtnUpdateDatail from './BtnUpdateDetail';
import { EstandarFormatoFecha, SumarDias } from '../Funciones';


const Objetivos = ({ objectivesProp, idDeliverableProp, deliverableProp, idObjectiveProp, objectiveProp, creationDateProp, createdByProp, idProjectProp, projectProp,
    individualMonthReportProp, setRunRenderProp, runRenderProp, readReportProp, reloadObjectiveProp, deliverablesProp, runRenderBlockProp, setRunRenderBlockProp,
    listObjectivesProp }) => {

    const [displayBasic, setDisplayBasic] = useState(false);
    const [setPosition] = useState('center');

    const dialogFuncMap = {
        'displayBasic': setDisplayBasic,
    }

    const [detailObjectives, setDetailObjectives] = useState([])

    useEffect(() => {
        var d = new Date()
        var gmtHours = -d.getTimezoneOffset() / 60;
        var newProjectProp = objectivesProp.map(item => {
            var newDate

            if (gmtHours < 0) {
                newDate = SumarDias(new Date(item.fechacumplimiento), 1)

            } else {
                newDate = new Date(item.fechacumplimiento)

            }
            return {
                estado: item.estado,
                fechacreacion: item.fechacreacion,
                fechacumplimiento: item.fechacumplimiento === null ? null : EstandarFormatoFecha(newDate),
                sendDate: item.fechacumplimiento,
                id: item.id,
                porcentajecumplimiento: item.porcentajecumplimiento,
                objetivo: item.objetivo,
                proyecto: item.proyecto
            }
        })

        if (individualMonthReportProp === true) {
            var newData = newProjectProp.filter(function (object) {
                var id = object.proyecto.id
                return id === parseInt(idProjectProp)
            })
            setDetailObjectives(newData)
        } else {
            setDetailObjectives(newProjectProp)
        }

    }, [objectivesProp, idProjectProp, individualMonthReportProp, deliverablesProp])

    const onClick = (name, position) => {
        dialogFuncMap[`${name}`](true);
        if (position) {
            setPosition(position);
        }
    }

    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    }
    const renderFooter = (name) => {
        return (
            <div>
                <Button label="Regresar" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text" />
            </div>
        );
    }

    // var permissionsObjectiveUpdate
    // if (permissionsProp[17].permisos[1] === "Editar") {
    //     permissionsObjectiveUpdate = true
    // } else {
    //     permissionsObjectiveUpdate = false
    // }
    // var permissionsObjectiveDelete
    // if (permissionsProp[17].permisos[2] === "Eliminar") {
    //     permissionsObjectiveDelete = true
    // } else {
    //     permissionsObjectiveDelete = false
    // }

    const [globalFilter, setGlobalFilter] = useState(null);
    const dt = useRef(null);

    const handleChange = (e) => {
        e.preventDefault();
    };

    const header = (
        <div className="headerTable">
            <div>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." className="p-column-filter" keyfilter={/^[^<>*!=°|(#$%&"_)+-.:;,/?¡¿'{}]+$/}
                        onCut={handleChange} onCopy={handleChange} onPaste={handleChange}
                    />
                </span>
            </div>
        </div>
    );

    const acctions = (rowData) => {
        /* console.log(rowData) */
        return (
            <>
                {readReportProp ?
                    null
                    :
                    <BtnUpdateDatail
                        idObjectiveDeliverableProp={rowData.id}
                        idDeliverableProp={idDeliverableProp}
                        deliverableProp={deliverableProp}
                        idObjectiveProp={rowData.objetivo.id}
                        objectiveProp={rowData.objetivo.descripcion}
                        projectProp={rowData.proyecto}
                        clientProp={rowData.proyecto.cliente}
                        percentageProp={rowData.porcentajecumplimiento}
                        dateProp={rowData.sendDate}
                        creationDateProp={creationDateProp}
                        createdByProp={createdByProp}
                        individualMonthReportProp={individualMonthReportProp}
                        setRunRenderProp={setRunRenderProp}
                        runRenderProp={runRenderProp}
                        reloadObjectiveProp={reloadObjectiveProp}
                        runRenderBlockProp={runRenderBlockProp}
                        setRunRenderBlockProp={setRunRenderBlockProp}
                        listObjectivesProp={listObjectivesProp}
                    />
                }
                {readReportProp ?
                    null :
                    <ConfirmBtn
                        tittle="Confirmar Eliminación"
                        menssage="¿Está seguro de eliminar esta asociación?, Recuerde que una vez se elimine, se borrará definitivamente del sistema"
                        action="Update"
                        label=""
                        classProp="p-button-danger"
                        icon="pi pi-trash"
                        tooltipProp="Eliminar"
                        idDeliverableProp={idDeliverableProp}
                        assingnedNewObjectiveDeliverableProp={true}
                        idObjectiveDeliverableProp={rowData.id}
                        idObjectiveProp={rowData.objetivo.id}
                        idProjectProp={rowData.proyecto.id}
                        creationDateObjectiveProp={rowData.fechacreacion}
                        deliverableProp={deliverableProp}
                        creationDateProp={creationDateProp}
                        percentageProp={rowData.porcentajecumplimiento}
                        createdByProp={createdByProp}
                        statusProp={3}
                        setRunRenderProp={setRunRenderProp}
                        runRenderProp={runRenderProp}
                        deleteDetailProp={true}
                        runRenderBlockProp={runRenderBlockProp}
                        setRunRenderBlockProp={setRunRenderBlockProp}
                    />
                }

            </>
        )
    }

    return (
        <>
            <Button icon="pi pi-eye" className="btnEditar p-button-secondary" style={{ marginTop: '5px' }} onClick={() => onClick('displayBasic')}
                tooltip="Asociaciones" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }}
            ></Button>
            <Dialog className="modal" header="Objetivos asociados" visible={displayBasic} style={{}} footer={renderFooter('displayBasic')} onHide={() => onHide('displayBasic')}>
                <div className="datatable-responsive-demo">
                    <div className="card">
                        <DataTable ref={dt} value={detailObjectives} className="p-datatable-responsive-demo" paginator rows={10}
                            emptyMessage="No hay asociaciones registradas para este entregable" header={header} globalFilter={globalFilter}>
                            <Column className="columna" field="proyecto.nombreproyecto" header="Proyecto" />
                            <Column className="columna" field="objetivo.descripcion" header="Objetivos" />
                            <Column className="columna" field="fechacumplimiento" header="Fecha cumplimiento" />
                            <Column className="columna" field="porcentajecumplimiento" header="Porcentaje cumplimiento" />
                            <Column header="Acciones" body={acctions} />
                        </DataTable>
                    </div>
                </div>
            </Dialog>
        </>
    )
}
export default Objetivos